// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"a0-z"};